import { connect } from 'react-redux'

import { getPromoCampaignIdFromPromoStoreEntry } from 'selectors/promoStoreSelectors'
import { getUserOrders } from 'selectors/user'

import { DiscountBanner } from './DiscountBanner'

const mapStateToProps = (state: any) => {
  const signupOrder = getUserOrders(state).toJS()
  const firstOrder = Object.values(signupOrder)[0]
  const signupPromoCode =
    firstOrder && typeof firstOrder === 'object' && 'prices' in firstOrder
      ? (firstOrder as { prices?: { promoCode?: string } }).prices?.promoCode
      : undefined

  if (!signupPromoCode) return { fallbackCampaignId: '' }

  const campaignId = getPromoCampaignIdFromPromoStoreEntry(state, signupPromoCode)

  return {
    fallbackCampaignId: String(campaignId),
  }
}

const DiscountBannerContainer = connect(mapStateToProps)(DiscountBanner)
export { DiscountBannerContainer as DiscountBanner }
